import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSalesPeriodStats } from '../../api/nicePayments.api';
import DownloadButton from '../../components/DownloadButton';
import SimpleHeader from '../../components/layout/SimpleHeader';
import SalesSearch from '../../components/statistics/SalesSearch';
import useAxios from '../../hooks/useAxios';
import exportTable from '../../lib/exportTable';
import { getCommonCodeLabel } from '../../lib/store';
import { ISalesExtStats, ISalesStatsPeriodParams } from '../../models/nicePayments.model';
import moment from 'moment';
import '../../styles/antdCustom.css';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import TableEmpty from '../../components/common/TableEmpty';

const StatisticsSalesNice = () => {
  const { t } = useTranslation();

  const { arr: res, isLoading, error, executeArr: execute } = useAxios<any>();
  //useLoader(isLoading, [error]);

  const [data, setData] = useState<ISalesExtStats[]>([]);

  useEffect(() => {
    if (res?.length) {
      // @ts-ignore
      const _data: any = _.cloneDeep(res.at(0)?.data);

      if (_data.length > 4) { //캠퍼스 2개 이상인 경우 추가
        //종합용 변수
        let paTuition = 0, dcTuition = 0, rfTuition = 0, aaTuition = 0;
        let paShuttle = 0, dcShuttle = 0, rfShuttle = 0;
        let paPlatTest = 0, dcPlatTest = 0, rfPlatTest = 0;
        let paSpecial = 0, dcSpecial = 0, rfSpecial = 0;
        let paCbon = 0, dcCbon = 0, rfCbon = 0;
        let paAlex = 0, dcAlex = 0, rfAlex = 0;
        let paEtc = 0, dcEtc = 0, rfEtc = 0;
        let paTotal = 0, dcTotal = 0, rfTotal = 0, aaTotal = 0;

        _data.forEach((item: ISalesExtStats) => {
          //직영,가맹 합계 매출 제외
          if (item.isCampus === 'Y') {
            if (item.typeCode === 'PA') {  //매출
              paTuition += item.tuition;
              paShuttle += item.shuttle;
              paPlatTest += item.platTest;
              paSpecial += item.special;
              paCbon += item.cbon;
              paAlex += item.alex;
              paEtc += item.etc;
              paTotal += item.total;
            } else if (item.typeCode === 'DC') { //할인
              dcTuition += item.tuition;
              dcShuttle += item.shuttle;
              dcPlatTest += item.platTest;
              dcSpecial += item.special;
              dcCbon += item.cbon;
              dcAlex += item.alex;
              dcEtc += item.etc;
              dcTotal += item.total;
            } else if (item.typeCode === 'RF') { //환불
              rfTuition += item.tuition;
              rfShuttle += item.shuttle;
              rfPlatTest += item.platTest;
              rfSpecial += item.special;
              rfCbon += item.cbon;
              rfAlex += item.alex;
              rfEtc += item.etc;
              rfTotal += item.total;
            } else if (item.typeCode === 'AA') { //인정결석
              aaTuition += item.tuition;
              aaTotal += item.total;
            }
          }
        });

        //종합 매출 추가 ZZ003 = DUMMY CAMPUS CODE
        _data.push({
          campusCode: 'ZZ003',
          campusName: t('statistics.refund.1'),
          campusNameEn: null,
          campusDiv: 'AL',
          isCampus: 'N',
          typeCode: 'PA',
          tuition: paTuition,
          shuttle: paShuttle,
          platTest: paPlatTest,
          special: paSpecial,
          cbon: paCbon,
          alex: paAlex,
          etc: paEtc,
          total: paTotal,
        });

        //종합 할인 추가 ZZ003 = DUMMY CAMPUS CODE
        _data.push({
          campusCode: 'ZZ003',
          campusName: t('statistics.refund.1'),
          campusNameEn: null,
          campusDiv: 'AL',
          isCampus: 'N',
          typeCode: 'DC',
          tuition: dcTuition,
          shuttle: dcShuttle,
          platTest: dcPlatTest,
          special: dcSpecial,
          cbon: dcCbon,
          alex: dcAlex,
          etc: dcEtc,
          total: dcTotal,
        });

        //종합 할인 추가 ZZ003 = DUMMY CAMPUS CODE
        _data.push({
          campusCode: 'ZZ003',
          campusName: t('statistics.refund.1'),
          campusNameEn: null,
          campusDiv: 'AL',
          isCampus: 'N',
          typeCode: 'RF',
          tuition: rfTuition,
          shuttle: rfShuttle,
          platTest: rfPlatTest,
          special: rfSpecial,
          cbon: rfCbon,
          alex: rfAlex,
          etc: rfEtc,
          total: rfTotal,
        });

        //종합 인정결석 추가 ZZ003 = DUMMY CAMPUS CODE
        _data.push({
          campusCode: 'ZZ003',
          campusName: t('statistics.refund.1'),
          campusNameEn: null,
          campusDiv: 'AL',
          isCampus: 'N',
          typeCode: 'AA',
          tuition: aaTuition,
          shuttle: 0,
          platTest: 0,
          special: 0,
          cbon: 0,
          alex: 0,
          etc: 0,
          total: 0,
        });
      }

      //각 구분 별 총매출 추가
      const makeData: any = [];
      let totalTuition = 0;
      let totalShuttle = 0;
      let totalPlatTest = 0;
      let totalSpecial = 0;
      let totalCbon = 0;
      let totalAlex = 0;
      let totalEtc = 0;
      let total = 0;
      let idxCount = 0;
      _data.forEach((item: any, idx: number) => {
        idxCount++;
        item.rowIdx = idxCount;
        if (item.typeCode === 'PA') {
          totalTuition += item.tuition;
          totalShuttle += item.shuttle;
          totalPlatTest += item.platTest;
          totalSpecial += item.special;
          totalCbon += item.cbon;
          totalAlex += item.alex;
          totalEtc += item.etc;
          total += item.total;
        } else if (item.typeCode === 'DC' || item.typeCode === 'RF') {
          totalTuition -= item.tuition;
          totalShuttle -= item.shuttle;
          totalPlatTest -= item.platTest;
          totalSpecial -= item.special;
          totalCbon -= item.cbon;
          totalAlex -= item.alex;
          totalEtc -= item.etc;
          total -= item.total;
        }

        makeData.push(item);

        if (idx % 4 === 3) {
          idxCount++;
          makeData.push({
            rowIdx: idxCount,
            campusCode: item.campusCode,
            campusName: item.campusName,
            campusNameEn: null,
            campusDiv: item.campusDiv,
            isCampus: item.isCampus,
            typeCode: 'TO',
            tuition: totalTuition,
            shuttle: totalShuttle,
            platTest: totalPlatTest,
            special: totalSpecial,
            cbon: totalCbon,
            alex: totalAlex,
            etc: totalEtc,
            total: total,
          });

          totalTuition = 0;
          totalShuttle = 0;
          totalPlatTest = 0;
          totalSpecial = 0;
          totalCbon = 0;
          totalAlex = 0;
          totalEtc = 0;
          total = 0;
        }

      });

      setData(makeData);
    }
  }, [res]);

  const onSearch = (
    req: ISalesStatsPeriodParams,
    prevReq?: ISalesStatsPeriodParams,
  ) => {
    const arr: any = [];
    arr.push(getSalesPeriodStats(req));
    if (prevReq) {
      arr.push(getSalesPeriodStats(prevReq));
    }
    execute(arr);
  };

  const onExportTable = () => {
    const _data = _.cloneDeep(data);
    _data.forEach((item: any, idx: number) => {
      item.rowIdx = idx;
      item.campusDiv = getCommonCodeLabel('CA0003', ('AL' === item.campusDiv ? '종합' : item.campusDiv) || '', 'ko');
      item.typeCode = getCommonCodeLabel('ST0002', item.typeCode || '', 'ko');
    });
    const currentDate = moment(new Date());
    exportTable(columns, _data, `${t('statistics.sales.1')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.sales.1'), [20, 10, 12, 15, 15, 17, 15, 15, 15, 15, 15]);
  };

  const columns: TableColumnsType<ISalesExtStats> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusName',
      key: 'campusName',
      align: 'center',
      onCell: (record) => ({
        rowSpan: (record.rowIdx % 5 === 1) ? 5 : 0,
      }),
    },
    {
      title: t('statistics.sales.store'),
      dataIndex: 'campusDiv',
      key: 'campusDiv',
      align: 'center',
      render: value => getCommonCodeLabel('CA0003', ('AL' === value ? '종합' : value) || '', 'ko'),
      onCell: (record) => ({
        rowSpan: (record.rowIdx % 5 === 1) ? 5 : 0,
      }),
    },
    {
      title: t('statistics.placementTest.column12'),
      dataIndex: 'typeCode',
      key: 'typeCode',
      align: 'center',
      render: value => getCommonCodeLabel('ST0002', value || '', 'ko'),
    },
    {
      title: t('statistics.sales.column1'),
      dataIndex: 'tuition',
      key: 'tuition',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column5'),
      dataIndex: 'shuttle',
      key: 'shuttle',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('payment.charge.option1'),
      dataIndex: 'platTest',
      key: 'platTest',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('payment.charge.option6'),
      dataIndex: 'special',
      key: 'special',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column2'),
      dataIndex: 'cbon',
      key: 'cbon',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('statistics.refund.column3'),
      dataIndex: 'alex',
      key: 'alex',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('statistics.refund.column5'),
      dataIndex: 'etc',
      key: 'etc',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column3'),
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      render: (value, record) => record.typeCode === 'RF' ?
        <span style={{ color: 'red' }}>{value?.toLocaleString()}</span> : value?.toLocaleString(),
    },
  ];

  return (
    <>
      <SimpleHeader
        iconFile="icon-statistics-big.svg"
        parentMenu={t('common.menu.statistics')}
        currentMenu={t('statistics.sales.title1')}
        onlyTitle={true}
      />
      <SalesSearch
        onSearch={onSearch}
      />
      <div className="content scrollbar">
        {isLoading && <Loader />}
        <ErrorResponse error={error} />
        {
          data.length
            ? (
              <div>
                <div className="comm-bx__space">
                  <div className="comm-btn__area right">
                    🏷️ {t('statistics.sales.msg1')}
                  </div>
                </div>
                <div className="comm-table__area">
                  <Table
                    columns={columns}
                    dataSource={data}
                    pagination={{
                      current: 1,
                      pageSize: 999999999,
                    }}
                    rowClassName={(record: ISalesExtStats) => record.isCampus === 'N' ? 'tfoot' : ''}
                    rowKey={'rowIdx'}
                    bordered
                  />
                </div>
                <div className="comm-bx__space">
                  <DownloadButton onClick={onExportTable} />
                </div>
              </div>
            )
            : (
              <TableEmpty text={t('statistics.appday.text1')} />
            )
        }
      </div>
    </>
  );
};

export default StatisticsSalesNice;